import { SafeError, SafePromise } from '@benzinga/safe-await';
import { PriceAlerts } from './proto/price_alerts_protos';

interface RestfulResult<DATA> {
  alerts: DATA;
  response_code: number;
}
interface CreateUpdateRestfulResult<T> {
  uuid: T;
}

export type PriceAlertsResult = RestfulResult<Record<PriceAlerts.Alert['uuid'], PriceAlerts.Alert>>;
export type CreateUpdatePriceAlertResult = CreateUpdateRestfulResult<string>;

export const ingresPriceAlerts = async (
  ingressPriceAlerts: SafePromise<PriceAlertsResult>,
): SafePromise<Partial<PriceAlerts.Alert>[]> => {
  const rawAlerts = await ingressPriceAlerts;

  if (rawAlerts.err) {
    return { err: rawAlerts.err };
  } else {
    if (Object.values(rawAlerts.ok).length > 0) {
      return {
        ok: Object.values(rawAlerts.ok.alerts).map(alert => ({
          callback: alert.callback,
          createdDate: alert.createdDate,
          priceAlert: {
            crossing: alert.priceAlert && alert.priceAlert.crossing,
            price: alert.priceAlert && alert.priceAlert.price,
          },
          status: alert.status,
          symbol: alert.symbol,
          triggeredDate: alert.triggeredDate,
          uuid: alert.uuid,
        })),
      };
    } else {
      return { ok: [] };
    }
  }
};

export const ingresAddUpdatePriceAlerts = async (
  ingresAddUpdatePriceAlerts: SafePromise<PriceAlerts.PostAlertResponse>,
): SafePromise<Partial<PriceAlerts.PostAlertResponse>> => {
  const rawAlerts = await ingresAddUpdatePriceAlerts;

  if (rawAlerts.err) {
    return { err: rawAlerts.err };
  } else {
    if (rawAlerts.ok) {
      return {
        ok: {
          uuid: rawAlerts.ok.uuid,
        },
      };
    } else {
      return { err: new SafeError('did not get a valid alerts', 'invalid_alerts') };
    }
  }
};
